$(window).on('load', function(){
(function() {
var base_url = 'https://myminicart.pro/mini/';
// gtglass.myshopify.com
var matchesMediaQuery = window.matchMedia('(max-width:999px) and (orientation:landscape)').matches;
var cart_prdctidsary = [],show_soldout=null,sd_enablepopup,cbground=null,sd_sliderhtml,sd_carttemplate=null,sdscope_update=null,checkoutbtntext=null,dark_headercolor=null,ctxt=null,sdrelated_enable=null,sd_notebox=null,sdrandom_enable=null,sd_progressbar=null,sdrandom_products,sdpopular_enable=null,cbuttonclr=null,shipping_disable=null,dropheadfoot=null,cartbuttontextcolorf=null,shopbuttontext=null,itemsinyourcart,totaltext=null,cartempty=null,fixcartbackground=null,shippingmsg=null,viewcartbtntext=null,viewcartbtnback=null,viewcartbtntextcolor=null,disablecheckout=null,disablefloating=null,topmargin=null,disableshop=null,sd_shopbtnlink=null,sddisablequantity=null,sdenableslider=null,sdcart_disable=null,sdheader_enable=null,sdheader_text=null,discount_field=null,sd_note_enable=null,sd_note_heading=null,money=null,iconname=null,fixedcartval=null,related_status = null,sd_topmarginvar=null,sd_disablefloating=null,sd_iconposition=null,fixcartbackground=null,background_procount=null,minimum_qtyamt = null,minimum_purchase_amount=null,minimum_purchase_qty=null,resultant_automatic=null,valid_ids,resulting_data,offer_percentage,more_percentage,off_discount,spend_money,recommendedProducts,randomProducts_data,sale_timeinterval,sd_enablenotification,sd_onmobile;
$("body").append("<div class='sd_fixminihover' style=''></div>");
$.ajax({
  url: base_url+'frontend-function.php',
  type: "POST",
  data: "csetting=money&shopname=" + Shopify.shop,
  async: false,
  success: function(response) {
    var json = $.parseJSON(response);
    money =  $.trim(json.money);

    if(money=="USD")
    {
      money = "$";
    }else if(money=="INR")
    {
      money = "Rs";
    }else if(money=="GBP")
    {
      money = "Â£";
    }else{ }
  if(Shopify.shop == 'beinghereee.myshopify.com'){ money = '';  }

    fixedcartval = $.trim(json.fixedcartval);
    sd_topmarginvar = $.trim(json.sd_topmarginvar+'px');
    sd_disablefloating = $.trim(json.sd_disablefloating);
    botharr =  $.trim(json.iconname).split(',');
    iconname = botharr[0];
    iconcount = botharr[1];
    sd_iconposition = $.trim(json.sd_iconposition);
    fixcartbackground = $.trim('#'+json.fixcartbackground);
    cbground = $.trim('#' + json.cbg);
    ctxt = $.trim('#' + json.ctxtcolor);
    cbuttonclr = $.trim('#' + json.cbuttoncolor);
    dropheadfoot = $.trim('#' + json.dropheadfoot);
    cartbuttontextcolorf =  $.trim('#' + json.cartbuttontextcolors);
    pricequant =  $.trim('#' + json.pricequant);
    fixcartbackground =  $.trim('#' + json.fixcartbackground);
    checkoutbtntext =  $.trim(json.checkoutbtntext);
    shopbuttontext =  $.trim(json.shopbuttontext);
    itemsinyourcart =  $.trim(json.itemsinyourcart);
    totaltext =  $.trim(json.totaltext);
    removetext = $.trim(json.removetext);
    cartempty =  $.trim(json.cartempty);
    shippingmsg = $.trim(json.shippingmsg);
    viewcartbtntext = $.trim(json.viewcartbtntext);
    viewcartbtnback =  $.trim('#' + json.viewcartbtnback);
    viewcartbtntextcolor =  $.trim('#' + json.viewcartbtntextcolor);
    disablecheckout =  $.trim(json.disablecheckout);
    disablefloating =  $.trim(json.disablefloating);
    topmargin =  $.trim(json.topmargin+'px');
    disableshop = $.trim(json.sd_disableshop);
    sd_shopbtnlink = $.trim(json.sd_shopbtnlink);
    sddisablequantity = $.trim(json.sd_disablequantity);
    sddisablemobile = $.trim(json.sd_disablemobile);
    sdenableslider = $.trim(json.sdenableslider);
    sdcart_disable = $.trim(json.sdcart_disable);
    sdheader_enable = $.trim(json.sdheader_enable);
    sdheader_text = $.trim(json.sddiscount_header);
    discount_field = $.trim(json.sddiscount_field);
    sd_note_enable = $.trim(json.sd_note_enable);
    sd_note_heading = $.trim(json.sd_note_heading);
    sdpopular_enable = $.trim(json.sd_popular_enable);
    sdrelated_enable = $.trim(json.sd_related_enable);
    sdrandom_products = $.trim(json.sd_random);
    sd_progressbar = $.trim(json.progressbar);
    sdrandom_enable = $.trim(json.sd_random_enable);
    shipping_disable = $.trim(json.shipping_disable);
    sd_notebox = $.trim(json.sd_notebox);
    sd_carttemplate = $.trim(json.sd_carttemplate);
    dark_headercolor = $.trim(json.dark_headercolor);
    sdscope_update = $.trim(json.scope_update);
    sd_enablepopup = $.trim(json.enable_popup);
    sd_hideProducts = $.trim(json.sd_hideProducts);
    show_soldout = $.trim(json.show_soldout);
    if(fixcartbackground=="" || fixcartbackground==null){fixcartbackground = "#494c50"; }if(iconname!="" && iconname!="default" && iconname!=null){ iconname = iconname; if(iconcount == 'default') { background_procount = base_url+"images/count_icon1.png"; }  else{ background_procount = base_url+"images/"+iconcount+".png";  } } else  {   iconname = 'cart_icon0';    background_procount = base_url+"images/count_icon1.png";  }

    // disable on mobile
    if ( $(window).width() <= 767  && sddisablemobile == 'disablemobile' || (matchesMediaQuery && sddisablemobile == 'disablemobile')) {
      console.log($(window).width());
      $('.sd_dropdown-mini-cart').html('');
      $('.sd_fixminihover').addClass('sd_disablemobile');
    }else{
    if(sd_iconposition=="left"){  $(".sd_fixminihover").append("<div class='sd_fixminicart sd_left img_"+iconname+"'><span class='sd_procounter sdcustomicon sd_leftcustom'></span><div class='sd_minifixinner'><img src="+base_url+"images/"+iconname+".png  class='sd_carticon sthemeimg' ></div></div><input type='button' class='sdloadclick' style='display:none'><div class='sd_mini-cart sd_left'><div class='sd_mini-cart-left'></div><div class='wrapper'><div class='cart-inner sd_carttemplate_two sd_mini-cart-items'></div></div></div>"); }
    else {    $(".sd_fixminihover").append("<div class='sd_fixminicart sd_right img_"+iconname+"'><span class='sd_procounter sdcustomicon sd_rightcustom'></span><div class='sd_minifixinner'><img src="+base_url+"images/"+iconname+".png  class='sd_carticon sthemeimg'></div></div><input type='button' class='sdloadclick' style='display:none'><div class='sd_mini-cart sd_right'><div class='sd_mini-cart-left'></div><div class='wrapper'><div class='cart-inner sd_carttemplate_two sd_mini-cart-items'></div></div></div>"); }
    }

    if(fixedcartval == 'yes') { $('.sd_fixminicart').css({'visibility': 'visible', 'opacity': '1'}); }else { $('.sd_fixminicart').css({'display': 'none'}); }
    if(sd_topmarginvar!='' && sd_topmarginvar!='px'){ $('.sd_fixminicart').css({'top': sd_topmarginvar}); }else { $('.sd_fixminicart').css({'top': '80px'});  }
    if(sd_disablefloating=='disablefloat'){   $('.sd_fixminicart').css({'position':'absolute'});    } else {  $('.sd_fixminicart').css({'position':'fixed'}); }
    setTimeout(function() { $('.sd_procounter').css({'background':'url("'+background_procount+'")'}); }, 1000); $('.sdloadclick').click();  } });

 //cart popup data start here
 if(sd_note_heading == "") { sd_note_heading = 'Notes'; } if(sdheader_text == '' || sdheader_text == null){ sdheader_text = 'Mini Cart'; } if(checkoutbtntext==""){ checkoutbtntext = "CHECKOUT"; } if(shopbuttontext==""){ shopbuttontext = "Shop"; } if(itemsinyourcart == '' || itemsinyourcart == null || itemsinyourcart == undefined){ itemsinyourcart = "items in your cart"; } if(totaltext==""){ totaltext = "Total"; } if(removetext==""){ removetext = "Remove"; } if(cartempty==""){ cartempty = "Add items to bag now"; } if(shippingmsg=="") { shippingmsg = "Shipping and taxes calculated at checkout"; } if(viewcartbtntext=="") {  viewcartbtntext = "View Cart"; }
 if(sd_carttemplate == 'Custom') {  $('.sd_dropdown-cart-items').css({'background': cbground}); $('.sd_dropdown-cart-items').css({'box-shadow': '0 54px 0 '+dropheadfoot+ ' inset'}); $('.mini-cart-subtotal').css({'background': dropheadfoot}); $('.sd_carticon').css({'background': fixcartbackground}); }
 $('.sd_carticon.sthemeimg').css({'background':'none'});
 if(disablefloating=='disablefloat'){ $('.sd_fixminicart').css({'position':'absolute'});  $('body').css({'overflow-x':'hidden'}); } else {  $('.sd_fixminicart').css({'position':'fixed'});   $('body').css({'overflow-x':'inherit'}); } if(topmargin!='' && topmargin!='px'){ $('.sd_fixminicart').css({'top': topmargin}); } else {   $('.sd_fixminicart').css({'top': '210px'}); } if(disableshop=="disableshop") {  $('.sd_shopproduct').css({'display':'none'}); } else{   $('.sd_shopproduct').css({'display':'block'}); }
 //open cart pop up when click on add to cart
 if(sdenableslider=="yesenable")
 {
  if((($(window).width() <= 767 || matchesMediaQuery)  && (sddisablemobile != 'disablemobile')) || ($(window).width() > 767) && (!matchesMediaQuery))
  {
    $('body,html').on('click', 'form[action="/cart/add"] button[type="submit"],form[action="/cart/add"] input[type="submit"],form[action="/cart/add"] input[type="button"],form[action="/cart/add"] button[type="button"]', function(e) {
      setTimeout(function(){  $('.sd_carticon').click();  $('body').css('overflow-x', 'hidden');    $('html').css('overflow', 'hidden');    }, 300);  });
    $('body,html').on('click', 'input[type="submit"]', function(e) {
      var thisval = $(this).val();
      if(thisval == 'Add to Cart'){
        setTimeout(function(){  $('.sd_carticon').click();  $('body').css('overflow-x', 'hidden');    $('html').css('overflow', 'hidden');    }, 1000);
      }
    });
  }
}



//open cart pop up when click on the add to cart button
if(sd_enablepopup == 'yesenable'){
    $('body').on('click', 'form[action="/cart/add"] button[type="submit"], form[action="/cart/add"] input[type="submit"],form[action="/cart/add"] input[type="button"],form[action="/cart/add"] button[type="button"]', function(e) {

        if($('.sd_dropdown-inner-area .sd_dropdown-cart-items').hasClass('sd_active'))
        {
        dropdowncart();
      }
      else{
      setTimeout(function(){
      dropdowncart();
      $('.sd_dropdown-inner-area .sd_dropdown-cart-items').slideToggle('slow');
    $('.sd_dropdown-inner-area .sd_dropdown-cart-items').toggleClass('sd_active');
    }, 700);
      }

  });
}
 if(sdcart_disable == 'yesenable')
 {
  if((($(window).width() <= 767 || matchesMediaQuery)  && (sddisablemobile != 'disablemobile')) || (($(window).width() > 767) && (!matchesMediaQuery))){
  $("a").click(function(e) {
    if($(this).attr("href") == '/cart'){
      e.preventDefault();
      setTimeout(function(){ $('.sd_carticon').click(); $('body').css('overflow-x', 'hidden');    $('html').css('overflow', 'hidden'); }, 10);
     } });
    }
 }


 $.ajax({
  url: base_url+'function.php',
  type: "POST",
  data: "chkrecentorders=chkrecentorders&shopname=" + Shopify.shop,
  success: function(responsenotify) {
    var notify_json = $.parseJSON(responsenotify);
    var notify_msg = $.trim(notify_json.notify_html);
    sale_timeinterval = $.trim(notify_json.sd_timeinterval);
    sd_enablenotification = $.trim(notify_json.sd_notification);
    sd_onmobile = $.trim(notify_json.onmobile);
    if(($(window).width() < 767) && sd_onmobile == 'enablenotificationmobile' ) { $(".sd_notification_popup").hide(); }
    else{
      if(sd_enablenotification == 'yes'){ $(".sd_fixminihover").append(notify_msg); }
    }
  }
 });

      //to show sales notification
      jQuery(document).ready(function ($) {
        setTimeout(function(){
          $(".sd_notification_popup").show().delay(sale_timeinterval).fadeOut();
        }, 8000);
      });

     // to clear local storage after 15 minutes
     setInterval(function () {
      localStorage.clear();
    },900000); //24 * 60mins * 60sec


     $(document).on("click", ".sd_left .sd_carticon", function() {
       console.log('left icon clicked');
      if($('.sd_dropdown-cart-items').css('display') == 'block')
      {     $('.sd_dropdown-inner-area .sd_dropdown-cart-items').slideUp();     }
      $('.sd_mini-cart').addClass('sd_left_minicart');
      $('.sd_mini-cart-items').css('left', '0%');
      setTimeout(function() {
        var itemname = localStorage.getItem("lastdiscountcode");
        if(itemname != null && ($('.sd_discnted').length == 0) && ($('.sd_codeinput').length > 0))
        {
          $(".sd_codeinput").val(itemname);
          $('.sd_codebtn').click();
        }
      }, 500);

     });

     $(document).on("click", ".sd_right .sd_carticon", function() {
      console.log('right icon clicked');
      if($('.sd_dropdown-cart-items').css('display') == 'block')
      {     $('.sd_dropdown-inner-area .sd_dropdown-cart-items').slideUp();     }
      $('.sd_mini-cart').addClass('sd_right_minicart');
      $('.sd_mini-cart-items').css('right', '0%');

      if(Shopify.shop == 'gtglass.myshopify.com'){
          var updated_price  = $(".totalprice").text();
          $(".sd-header-text").text(updated_price);
      }

      setTimeout(function() {
        var itemname = localStorage.getItem("lastdiscountcode");
        if(itemname != null && ($('.sd_discnted').length == 0) && ($('.sd_codeinput').length > 0))
        { $(".sd_codeinput").val(itemname);   $('.sd_codebtn').click();         }
      }, 500);
     });

     $(document).on('click', '.sd_left .sidesd_cross_image, .sd_left .sd_mini-cart-left', function() {
      $('.sd_mini-cart').removeClass('sd_left_minicart');
      $('.sd_fixminicart').removeClass('sd_fixactive');
      $('.sd_fixminicart').css('visibility', 'visible');
      $('.sd_mini-cart').fadeOut('slow');
      $('.sd_mini-cart-items').css('left', '-100%');
      $('body,html').css('overflow', 'auto');
      $('body').css({'overflow-x':'hidden'});
      if($(window).width() < 767) { $('body').css({'position':'relative'}); }
     });

     $(document).on('click', '.sd_right .sd_mini-cart-left,.sd_right .sidesd_cross_image', function() {
      $('.sd_mini-cart').removeClass('sd_right_minicart');
      $('.sd_fixminicart').removeClass('sd_fixactive');
      $('.sd_fixminicart').css('visibility', 'visible');
      $('.sd_mini-cart').fadeOut('slow');
      $('.sd_mini-cart-items').css('right', '-100%');
      $('body,html').css('overflow', 'auto');
      $('body').css({'overflow-x':'hidden'});
      if($(window).width() < 767) { $('body').css({'position':'relative'}); }
     });

     var hostname = window.location.hostname;
     $.ajax({
      type: 'GET',
      url: 'https://' + hostname + '/cart.json',
      dataType: 'json',
      success: function(datas) {
        var sd_counter = datas['item_count'];
        $('.sd_procounter').text(sd_counter);
        $('.dropcount').text('('+sd_counter+')');
        $('#CartCount span').text(sd_counter);
      }
     });
     $('.sd_fixminihover').hover(function() {
      $.fn.shake = function() {
        this.each(function(i) {
          $(this).css({ "position" : "relative" });
          for (var xloop = 1; xloop <= 1; xloop++) {
            $(this).animate({ right: -48 }, 50).animate({ right: -51 }, 80).animate({ right: -48},50).animate({ right: -51 }, 80).animate({ right: -48 }, 50);
          }
        });
        return this;
      }
      $('.sd_procounter.sdcustomicon.sd_leftcustom').shake();
     });

     $('.sd_fixminihover').hover(function() {
      $.fn.shake = function() {
        this.each(function(i) {
          $(this).css({ "position" : "relative" });
          for (var xloop = 1; xloop <= 1; xloop++) {
            $(this).animate({ left: -51 }, 50).animate({ left: -48 }, 80).animate({ left: -51},50).animate({ left: -48 }, 80).animate({ left: -51 }, 50);
          }
        });
        return this;
      }
      $('.sd_procounter.sdcustomicon.sd_rightcustom').shake();
     });

     $('.sd_fixminihover').hover(function() {
      $.fn.shake = function() {
        this.each(function(i) {
          $(this).css({ "position" : "relative" });
          for (var xloop = 1; xloop <= 1; xloop++) {
            $(this).animate({ right: -28 }, 50).animate({ right: -25 }, 80).animate({ right: -28},50).animate({ right: -25 }, 80).animate({ right: -28 }, 50);
          }
        });
        return this;
      }
      $('.sd_procounter.sddefaulticons.sd_leftdef').shake();
     });

     $(document).on('click', '.sd_removediscount', function(e){
      e.preventDefault();
      setTimeout(function() {
        $('.sd_minifixinner').click();
        localStorage.clear();
      }, 20);
     });

     //on select dropdown option for add to cart in slider
        $(document).on('change', '.sd_mySelection', function(){
        var selected_id = $(this).children(":selected").attr("data-id");
        var selected_varPrc = $(this).children(":selected").attr("product-price");
        $(this).parent().parent().find('.prices').text(selected_varPrc);
     if(selected_id == 'sd_soldout'){
          $(this).next('.sd_add_to_cart').html('Sold Out');
     }else{
            $(this).next('.sd_add_to_cart').html(' <span><svg width="10" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg"><path d="M11 5H7V1a1 1 0 00-2 0v4H1a1 1 0 000 2h4v4a1 1 0 002 0V7h4a1 1 0 000-2z" fill="currentColor" fill-rule="nonzero"></path></svg></span>Add');
     }
         });

// add product to cart from related product slider
$(document).on('click', '#sd_add_to_cart', function(e){
  e.preventDefault();
  var discount_value = $('.footer-code').attr('data');
   var p_id = $(this).attr('data-id');
   var variant_id = $('#sd_mySelectionBox'+p_id+' option:selected').attr('variant_id');
  $.ajax({
    type: 'POST',
    url: 'https://' + hostname + '/cart/add.js',
    data: 'quantity=1&id='+variant_id,
    async: false,
    cache: false,
    dataType: 'json',
    success: function(cartd)
    {
      setTimeout(function() {
        $('.sd_minifixinner').click();
      }, 20);
      if(discount_value != '' && discount_value != undefined)
      {
        setTimeout(function() {
          $("#sd_discount").val(discount_value);
          $('.sd_codebtn').click();
        }, 600);
      }
    }
  });
});
//related product ends

$(document).on('click', '.sd_altera', function(){
  var discount_value = $('.footer-code').attr('data');
  var upinput = $(this).parent().find('#sd_updatequant').val();
  if ($(this).hasClass('sdplus'))
    $(this).parent().find('#sd_updatequant').val(parseInt(upinput)+1);
  else if(upinput>1)
    $(this).parent().find('#sd_updatequant').val(parseInt(upinput)-1);
  var newinput = $(this).parent().find('#sd_updatequant').val();
  var proids = $(this).parent().find('#sd_updatequant').attr("prokey");
  var line_item = parseInt(proids) + 1;
  $.ajax({
    type: 'POST',
    url: 'https://' + hostname + '/cart/change.js',
    data: 'quantity='+newinput+'&line='+line_item,
    async: false,
    cache: false,
    dataType: 'json',
    success: function(cartd)
    {

      setTimeout(function() {
        dropdowncart();
        $('.sd_minifixinner').click();
      }, 20);
      if(discount_value != '' && discount_value != undefined )
      {
        setTimeout(function() {
          $("#sd_discount").val(discount_value);
          $('.sd_codebtn').click();
        }, 600);
      }
    }
  });
});

$(document).on('keydown','#sd_updatequant', function (event) {
  var discount_value = $('.footer-code').attr('data');
  $('#sd_updatequant').removeClass('as_active_input');
  $(this).addClass('as_active_input');
  var regex = new RegExp("^[0-9\b]+$");
  var key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
  if (!regex.test(key)) {
    event.preventDefault();
    return false;
  }

  setTimeout(function() {
    var newinput = $('.as_active_input').val();
    var proids = $('.as_active_input').attr("prokey");
    var line_item = parseInt(proids) + 1;
    $.ajax({
      type: 'POST',
      url: 'https://' + hostname + '/cart/change.js',
      data: 'quantity='+newinput+'&line=' + line_item,
      async: false,
      cache: false,
      dataType: 'json',
      success: function(cartd)
      {
        setTimeout(function() {
          $('.sd_minifixinner').click();
        }, 20);
        if(discount_value != '' && discount_value != undefined)
        {
          setTimeout(function() {
            $("#sd_discount").val(discount_value);
            $('.sd_codebtn').click();
          }, 600);
        }
      }
    });
  }, 500);
});

$(document).on('click', '.sd_maltera', function(){
  var upinput = $(this).parent().find('#sd_dropupdatequant').val();
  if ($(this).hasClass('sdplus'))
    $(this).parent().find('#sd_dropupdatequant').val(parseInt(upinput)+1);
  else if(upinput>1)
    $(this).parent().find('#sd_dropupdatequant').val(parseInt(upinput)-1);
  var newinput = $(this).parent().find('#sd_dropupdatequant').val();
  var proids = $(this).parent().find('#sd_dropupdatequant').attr("prokey");
  var line_item = parseInt(proids) + 1;
  $.ajax({
    type: 'POST',
    url: 'https://' + hostname + '/cart/change.js',
    data: 'quantity='+newinput+'&line=' + line_item,
    async: false,
    cache: false,
    dataType: 'json',
    success: function(cartd)
    {
      setTimeout(function() {
        $.ajax({
          type: 'GET',
          url: 'https://' + hostname + '/cart.json',
          dataType: 'json',
          success: function(datas) {
            var sd_countertotal = datas['item_count'];
            var sd_pricetotal = (datas['total_price'] / 100).toFixed(2);
            $('.sd_dropquanttotal').text(sd_countertotal);
            $('.sd_droptotals').text(' '+sd_pricetotal);
          }
        });
      }, 20);
    }
  });
});

$(document).on('keydown','#sd_dropupdatequant', function (event) {
  $('#sd_dropupdatequant').removeClass('as_active_input');
  $(this).addClass('as_active_input');
  var regex = new RegExp("^[0-9\b]+$");
  var key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
  if (!regex.test(key)) {
    event.preventDefault();
    return false;
  }
  setTimeout(function() {
    var newinput = $('.as_active_input').val();
    var proids = $('.as_active_input').attr("prokey");
    var line_item = parseInt(proids) +1;
    $.ajax({
      type: 'POST',
      url: 'https://' + hostname + '/cart/change.js',
      data: 'quantity='+newinput+'&line=' + line_item,
      async: false,
      cache: false,
      dataType: 'json',
      success: function(cartd)
      {
        $.ajax({
          type: 'GET',
          url: 'https://' + hostname + '/cart.json',
          dataType: 'json',
          success: function(datas) {
            var sd_countertotal = datas['item_count'];
            var sd_pricetotal = (datas['total_price'] / 100).toFixed(2);
            $('.sd_dropquanttotal').text(sd_countertotal);
            $('.sd_procounter').text(sd_countertotal);
            $('#CartCount span').text(sd_countertotal);
            $('.dropcount').text('('+sd_countertotal+')');
            $('.sd_droptotals').text(' '+sd_pricetotal);
          }
        });
      }
    });
  }, 500);
});
/**********************************Sidebar mini cart Start here************************************/
/* onload site fetch cart items */
$(document).on('click', '.sdloadclick', function() {
  fixminicart();
  setTimeout(function() {
    append_slider();
  }, 100);
});
/* end onload site fetch cart items */

/* onclick bag button refresh cart items */
$(document).on('click', '.sd_minifixinner', function() {
  console.log('11111111111111111111111111');
  $('.sd_mini-cart').fadeIn('slow');
  fixminicart();
  append_slider();
  setTimeout(function() {
    swipe_slick();
  }, 1000);
});

$.ajax({
  'async': false,
  type: 'POST',
  url: base_url+'discount_code.php',
  dataType: 'json',
  data:{autodiscount_cd:'autodiscount_cd', shopname : Shopify.shop},
  success: function(dataresult) {
    if(dataresult != '')
    {
      resultant_automatic = dataresult['data'];
      valid_ids = dataresult['discounted_ids'];
      buyprdids = dataresult['buyprdids'];
    }
  }
});

setTimeout(function() {
  if(sdrandom_products != '' && sdrandom_products != null)
  {
    $.ajax({
      type: 'POST',
      url: base_url+'frontend-function.php',
      dataType: 'json',
      data:{csetting:'sdrandom_products', shopname : Shopify.shop, randomprd_ids: sdrandom_products},
      success: function(random_response){
        randomProducts_data = random_response['products'];
      }
    });
  }
}, 200);
function fixminicart() {
  $.ajax({
    type: 'GET',
    url: 'https://' + hostname + '/cart.json',
    dataType: 'json',
    async:false,
    success: function(data) {
      resulting_data = JSON.stringify(data);
      cart_items = data['items'];
      var cart_list = [], cart_productsids_array = [], cart_discntitems = [],cart_variantids_array = [], cart_quantity_ary = [],  colprdids = [], prdvrtids = [], buy_ids = [], cart = [];
      var cart_price = 0, cart_quantity = 0, cart_buyquantity = 0, cart_getquantity = 0, totl_buyprice = 0, cart_getprice = 0, cart_buyprice = 0,cartbuy_itemTitle,get_itemtitle='';
      $.each( cart_items, function( i, value ) {
        cart_productsids_array.push( value.product_id );
        cart_variantids_array.push(value.variant_id);
        cart_prdctidsary.push(value.product_id )
        cart_quantity_ary.push(value.quantity);
      });
      var combine_cartids = $.merge(cart_productsids_array,cart_variantids_array)
      var cart_total = data['original_total_price']/100;
      var item_count = data['item_count'];
      $('.sd_procounter').text(item_count);
      $('#CartCount span').text(item_count);
      $('.dropcount').text('('+item_count+')');
      var total_price = data['original_total_price'] / 100;
      var product_count = data['items'].length;
      if (item_count > 0) {
        jQuery.post('https://' + hostname + '/cart/update.js',{updates: cart_quantity_ary},function(result){
        });
        if(sd_carttemplate == 'Custom')
          {       $('.sd_mini-cart-items.Custom').css({'background': cbground});  }
        $('.cartcount').text('(' + item_count + ')');
      }
      else
      {
        $('.cartcount').text('(0)');
        $(".sd-header-text").html(money +'0.00');
      }
      cart_list.push('<span class="close sidesd_cross_image"><svg height="329pt" viewBox="0 0 329.26933 329" width="329pt" xmlns="http://www.w3.org/2000/svg"><path d="m194.800781 164.769531 128.210938-128.214843c8.34375-8.339844 8.34375-21.824219 0-30.164063-8.339844-8.339844-21.824219-8.339844-30.164063 0l-128.214844 128.214844-128.210937-128.214844c-8.34375-8.339844-21.824219-8.339844-30.164063 0-8.34375 8.339844-8.34375 21.824219 0 30.164063l128.210938 128.214843-128.210938 128.214844c-8.34375 8.339844-8.34375 21.824219 0 30.164063 4.15625 4.160156 9.621094 6.25 15.082032 6.25 5.460937 0 10.921875-2.089844 15.082031-6.25l128.210937-128.214844 128.214844 128.214844c4.160156 4.160156 9.621094 6.25 15.082032 6.25 5.460937 0 10.921874-2.089844 15.082031-6.25 8.34375-8.339844 8.34375-21.824219 0-30.164063zm0 0"/></svg></span><form action="/cart" method="post" class="sd_cartform" name="cartform">');
               //If there are items in cart
               if (item_count > 0) {
                $(".cart-inner").addClass(sd_carttemplate);
                    // cart count
                     // mini cart data
                     $('.sd_mini-cart').attr('id', 'mini-cart');
                     if(sdheader_enable == 'yesenable')
                     {
                      cart_list.push('<div class="bg-yellow"><p><img src="'+base_url+'images/yellow-icon.png" alt="icon">'+sdheader_text+'</p></div>');
                     }
                     function intersect(a, b) {
                      return a.filter(Set.prototype.has, new Set(b));
                     }
                     if(resultant_automatic != '' && resultant_automatic != null)
                     {
                      if(valid_ids == 'All')
                      {
                        var combine_ids = cart_productsids_array;
                      }
                      else if(valid_ids != 'All')
                      {
                        var new_validids = valid_ids.map((i) => Number(i));
                        var combine_ids = intersect(new_validids, cart_productsids_array);
                      }
                      if(combine_ids != '')
                      {
                        var discount_typename = resultant_automatic['automaticDiscount']['__typename'];
                        if(discount_typename == 'DiscountAutomaticBasic')
                        {
                          var discount_type = resultant_automatic['automaticDiscount']['customerGets']['value']['__typename'];
                          if(discount_type == 'DiscountAmount')
                          {
                            var offer_amount = resultant_automatic['automaticDiscount']['customerGets']['value']['amount']['amount'];
                            var offer_amount_value = money+' '+offer_amount+' Off';
                          }
                          else if(discount_type == 'DiscountPercentage')
                          {
                            var offer_amount = resultant_automatic['automaticDiscount']['customerGets']['value']['percentage']*100;

                            var offer_amount_value = (offer_amount.toString().split(".")[0])+'% Off';
                          }
                          var minimumRequirement = resultant_automatic['automaticDiscount']['minimumRequirement']['__typename'];
                          if(minimumRequirement == 'DiscountMinimumSubtotal')
                          {

                            minimum_purchase_amount = resultant_automatic['automaticDiscount']['minimumRequirement']['greaterThanOrEqualToSubtotal']['amount'];
                          }
                          else if(minimumRequirement == 'DiscountMinimumQuantity')
                          {
                            minimum_purchase_qty = resultant_automatic['automaticDiscount']['minimumRequirement']['greaterThanOrEqualToQuantity'];
                          }

                          if(minimum_purchase_amount != null)
                          {
                            $.each( cart_items, function( i, value ) {
                              if(jQuery.inArray(value.product_id, combine_ids) != -1) {
                                cart_price = cart_price + (value['price']/100)*value['quantity'];
                                $('.sd_discounted').css({"display":"none"});
                              }
                            });
                            if(cart_price < minimum_purchase_amount)
                            {
                              spend_amount = minimum_purchase_amount-cart_price;
                              offer_percentage = (cart_price/minimum_purchase_amount)*100;
                              cart_list.push('<div class="pro-bar p-3 sd_discnt"><p>ADD <span>'+money+' '+(spend_amount.toFixed(2))+'</span> MORE TO GET <span class="pink-text">'+offer_amount_value+'</span></p><div class="pro-outer"><div class="progressbar" style="width: '+offer_percentage+'%; background: #'+sd_progressbar+';"></div></div></div>');
                              var minimum_qtyamt = "notsufficient";
                            }
                            else
                            {
                              var minimum_qtyamt = "sufficient";
                            }
                          }

                          if(minimum_purchase_qty != null)
                          {
                            $.each( cart_items, function( i, value ) {
                              if(jQuery.inArray(value.product_id, combine_ids) != -1) {
                                cart_quantity = cart_quantity + value['quantity'];
                              }
                            });
                            if(cart_quantity < minimum_purchase_qty )
                            {
                              var spend_quantity = minimum_purchase_qty-cart_quantity;
                              var offer_percentage = (cart_quantity/minimum_purchase_qty)*100;
                              $('.sd_discnted').css({"display":"none"});
                              var minimum_qtyamt = "notsufficient";
                              cart_list.push('<div class="pro-bar p-3 sd_discnt"><p>ADD <span>'+spend_quantity+' Items</span> MORE TO GET <span class="pink-text">'+offer_amount_value+'</span></p><div class="pro-outer"><div class="progressbar" style="width: '+offer_percentage+'%; background: #'+sd_progressbar+';"></div></div></div>');
                            }
                            else
                            {
                              var minimum_qtyamt = "sufficient";
                            }
                          }
                        }

                        else if(discount_typename == 'DiscountAutomaticBxgy'){
                          $.each( cart_items, function( i, value ) {
                            if(jQuery.inArray(value.product_id, combine_ids) != -1) {
                              cart_getquantity = cart_getquantity + value['quantity'];
                              cart_getprice = cart_getprice + value['price'];
                              cartget_itemTitle = value['product_title'];
                            }
                          });
                          $.each( cart_items, function( i, value ) {
                            if(jQuery.inArray(value.product_id, buyprdids) != -1) {
                              cart_buyquantity = cart_buyquantity + value['quantity'];
                              totl_buyprice = cart_buyprice + value['price'];
                              var cartbuy_itemTitle = value['product_title'];
                            }
                          });
                          $.each( cart_items, function( i, item_title ) {
                            if(item_title.total_discount != 0)
                            {
                              cart_discntitems.push(item_title.product_title);
                            }
                          });
                          get_itemtitle =cart_discntitems.join();
                          var total_cartbuygetqty = cart_getquantity + cart_buyquantity;
                          var total_cartbuygetamt = cart_getprice + cart_buyprice;
                          var buy_requirementtype = resultant_automatic['automaticDiscount']['customerBuys']['value']['__typename'];
                          var offer_amount_value = resultant_automatic['automaticDiscount']['customerGets']['value']['effect']['percentage']*100+'% OFF on ';
                          var minimum_qtyamt = "sufficient";
                        }
                        if((minimum_qtyamt == 'sufficient' || minimum_qtyamt == null) && (data['original_total_price'] != data['total_price']))
                        {

                          discounted_amount = data['total_price']/100;
                          if(discounted_amount == 0)
                          {
                            var eachoff = " on each product"
                          }
                          else
                          {
                            var eachoff = '';
                          }
                          setTimeout(function() {
                            $(".sd_discount-box").css("display","none");
                            $('.totalprice').html(money + ' ' + discounted_amount.toFixed(2));
                            console.log('totalPrice');

                            $('.sd_discountamount').html(money + ' ' + cart_total.toFixed(2));
                            $('.sd_discountamount').css({"text-decoration":"line-through"});
                          }, 100);
                          cart_list.push('<div class="pro-bar p-3 sd_discnted"><p>YOU HAVE QUALIFIED FOR <span class="pink-text">'+offer_amount_value+' '+get_itemtitle+' '+eachoff+'</span></p><div class="pro-outer"><div class="progressbar" style="width: 100%; background: #'+sd_progressbar+';"></div></div></div>');
                        }
                        else
                        {
                          setTimeout(function() {
                            $(".sd_discount-box").css("display","block");
                          }, 100);
                        }
                      }

                     }
                     cart_list.push('<div class="product-outer p-3"><div class="productbox"><h3 class="heading">'+item_count+' '+itemsinyourcart+'</h3>');
                     for (var i = 0; i < product_count; i++) {
                      if (data['items'][i]['id'] != null) {
                        var item_id = data['items'][i]['id'];
                        var product_title = data['items'][i]['product_title'];
                        var variant_title = data['items'][i]['variant_title'];
                        var product_handle = data['items'][i]['handle'];
                        var quantity = data['items'][i]['quantity'];
                        var line_price = data['items'][i]['price'] / 100;
                        var url = data['items'][i]['url'];
                        var image_url = data['items'][i]['image'];
                        var variants = data['items'][i]['variant_options'];
                        var product_key = data['items'][i]['key'];
                        var product_length = product_title.length;
                        if(image_url == null)
                        {
                          image_url = base_url+'images/no-image.png';
                        }

                        if(product_length > 15)
                        {
                          product_title =  product_title.substring(0, 15)+'....';
                        }
                        if(variant_title == null)
                        {
                          variant_title = '';
                        }
                        if (product_title == 'Gift Wrap') {
                          var product_url = product_title;
                        } else {

                          var product_url = '<h3 class="title m-0"><a href="https://' + hostname + '' + url + '">' + product_title + '<span class="sd_variant">'+variant_title+'</span></a></h3>';
                        }

                        if(disablecheckout=="disablecheck"){
                          var dynabutton = '<a class="b_checkout" href="https://' + hostname + '/cart">'+viewcartbtntext+'</a>';
                        }else{
                          var dynabutton =  '<input id="sd_valid_discount" type="hidden" name="discount"><button name="checkout" class="b_checkout">'+checkoutbtntext+'</button>';
                        }
                        if(sddisablequantity=="disablequantity" && sddisablequantity!=null){
                          var quantitybox = '<span class="product_qua" style="padding-top:12px;">X ' + quantity + '</span>';
                        }
                        else {
                          var quantitybox = '<span class="sd_q_update quantitybox"><button type="button" class="sd_altera sdminus"><svg width="10" viewBox="0 0 12 2" xmlns="http://www.w3.org/2000/svg"><path d="M11.25 0H.75C.3 0 0 .4 0 1s.3 1 .75 1h10.5c.45 0 .75-.4.75-1s-.3-1-.75-1z" fill="#7A7A7A" fill-rule="nonzero"></path></svg></button><input type="text" id="sd_updatequant" name="updatequant" value="'+ quantity +'" proid="' + item_id + '" prokey="'+i+'"><button type="button" class="sd_altera sdplus down"><svg width="10" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg"><path d="M11 5H7V1a1 1 0 00-2 0v4H1a1 1 0 000 2h4v4a1 1 0 002 0V7h4a1 1 0 000-2z" fill="currentColor" fill-rule="nonzero"></path></svg></button></span>';
                        }
                        var options = [];
                        for (var o = 0; o < variants.length; o++) {
                          var selected = data['items'][i]['variant_options'][o];
                          if (selected !== 'Default Title') {
                            options.push(selected);
                          }
                        }
                        var selected_options = options.join('');
                        cart_list.push('<hr class="m-0"><div class="product-inner row mini-cart-product ' + item_id + '"><div class="product_image image"><a href="javascript:void(0);"><img src="' + image_url + '"  alt="' + product_title + '" /></a></div><div class="pro-content"><div class="cartproname prohead">' + product_url + '</div><div class="pro-quantity"><div class="quantity-selector"><span class="price product_price">' + ' ' + money + ' ' + line_price.toFixed(2) + '</span>'+ quantitybox + '<input type="hidden" id="updates_' + item_id + '" value="' + quantity + '" /> <span class="product_price"> </span><a class="removeproduct remove" id="bag_product"' + item_id + '"" href="https://' + hostname + '/cart/change?line=1&amp;quantity=0" rel="' + i + '">'+removetext+'</a></div></div></div></div>');
                        } //endif
                    } // endfor
                    cart_list.push('</div></div>');
                    // cart_list.push('</div">');
                    //neha updated code
                    if(sd_note_enable == 'yesenablenote' || sd_note_enable == '' || sd_note_enable == null)
                    {
                      cart_list.push('<div class="sd_note p-3">');
                      if(sd_notebox == 'yesenablebox' || sd_notebox == '' || sd_notebox == null)
                      {
                        cart_list.push('<p class="add-optional">'+sd_note_heading+'</p><textarea name="note" id="CartSpecialInstructions" class="sd_note__input" data-cart-notes="" ></textarea></div>');
                      }
                      else{
                        cart_list.push('<p class="add-optional sd_noteheading">'+sd_note_heading+'</p><textarea name="note" id="CartSpecialInstructions" class="sd_note__input" data-cart-notes="" style="display:none;"></textarea></div>');
                      }
                    }
                  cart_list.push('<div class="sd_sliderdata"></div>');
                  // cart_list.push(' <div class="slidebox p-3 py-0"><h3 class="heading">'+item_count+' '+itemsinyourcart+'</h3><div class="slide-main"><span class="iconoutr pre-view"><i class="arrow left-icon"></i></span> <div class="slider-inner"><div class="slide-item"><div class="slide-image"><a href="javascript:void(0);"><img class="small" src="'+base_url+'images/slider-img.png" alt="img"></a></div><div class="slide-text"><a href="javascript:void(0);">Men Green jacket</a><p class="prices">$20.00</p></div><div class="slide-add"><button> <span><svg width="10" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg"><path d="M11 5H7V1a1 1 0 00-2 0v4H1a1 1 0 000 2h4v4a1 1 0 002 0V7h4a1 1 0 000-2z" fill="currentColor" fill-rule="nonzero"></path></svg></span>Add</button></div></div></div><span class="iconoutr next"><i class="arrow right-icon"></i></span></div></div>');
                  cart_list.push('<div class="sd_emptydiv"></div>')
                  cart_list.push('<div class="discount-box p-3 sd_discount-box">');
                  if((discount_field == 'yesenable' && ($('.sd_discnted').length == 0)) || ((discount_field == '' || discount_field == null) && sdscope_update == 1))
                  {
                    cart_list.push('<div class="sd_discountbox-form discount-box-form"><input type="text" name="discount" placeholder="Discount code" class="sd_codeinput" id="sd_discount" value=""></button><button type="button" class="sd_codebtn"><i class="fa fa-spinner fa-spin" style="display:none";></i>Apply</button><span class="invalid-coupon-code"></span></div>');
                  }
                  cart_list.push('</div>');
                  if(Shopify.shop == 'gtglass.myshopify.com'){
                    $(".sd-header-text").text(money + ' ' + total_price.toFixed(2));
                  }
                  cart_list.push('<div class="sd_side_mini-cart-subtotal checkoutbox"><div class="minitotal total"><span class="totalname">'+totaltext+'<strong class="totalprice">' + money + ' ' + total_price.toFixed(2) + '</strong></span><span class="sd_discountamount"></span><p class="sd_notpredict"></p>');
                    if(shipping_disable == 'nodisableshipmesssage')
                  {
                    cart_list.push('<p class="sd_shipping">'+shippingmsg+'</p>');
                  }
                  cart_list.push('</div><div class="sd_sidebar_check">'+dynabutton+'</div><a class="sd_viewcart" href="https://' + hostname + '/cart">'+viewcartbtntext+'</a>');


                  cart_list.push('</div></form></div>');

                    $('.sd_mini-cart-items').html(cart_list.join(''));

                      if(cbuttonclr!=null && cbuttonclr!='#')
                      {
                        if(disablecheckout=="disablecheck"){
                          $('.sd_mini-cart-items .b_checkout').css({'background': viewcartbtnback});
                        }else{
                          $('.sd_mini-cart-items .b_checkout').css({'background': cbuttonclr});
                        }
                      }

                      if(viewcartbtnback!=null && viewcartbtnback!='#')
                      {
                        $('.sd_viewcart').css({'background': viewcartbtnback});
                      }

                      if(ctxt!=null && ctxt!='#')
                      {
                        $('.cartproname a').css({'color': ctxt});
                      }

        if(sd_carttemplate == 'Custom' )
        {
          if(pricequant!=null && pricequant!='#')
          {
            $('.totalprice').css({'color': pricequant});
            $('.sd_discountamount').css({'color': pricequant});
            $('.product_qua').css({'color': pricequant});
            $('.product_price').css({'color': pricequant});
            $('h2 span').css({'color': pricequant});
            $('.bg-yellow').css({'background': "#"+dark_headercolor});
          }

          if(viewcartbtntextcolor!=null && viewcartbtntextcolor!='#')
          {
            $('.sd_viewcart').css({'color': viewcartbtntextcolor});
          }
          if(cartbuttontextcolorf!=null && cartbuttontextcolorf!='#')
          {
            if(disablecheckout=="disablecheck"){
              $('.sd_mini-cart-items .b_checkout').css({'color': viewcartbtntextcolor});
            }else{
              $('.sd_mini-cart-items .b_checkout').css({'color': cartbuttontextcolorf});
            }

          }
        }
        else{
          if(viewcartbtntextcolor!=null && viewcartbtntextcolor!='#')
          {
            $('.sd_viewcart').css({'color': '#fff'});
          }
        }


        if(disablecheckout=="disablecheck"){
          $('.sd_viewcart').remove();
        }else{
        }
      }
      else {
        $(".cart-inner").removeClass(sd_carttemplate);
        if(itemsinyourcart == "")
        {
          itemsinyourcart = "0 items in your Cart";
        }

        if(disablecheckout=="disablecheck"){
          var dynabutton = '<a class="b_checkout" href="https://' + hostname + '/cart">'+viewcartbtntext+'</a>';
        }else{
          var dynabutton = '<input id="sd_valid_discount" type="hidden" name="discount"><form action="/cart" method="post" ><button name="checkout" class="b_checkout">'+checkoutbtntext+'</button></form>';
        }
        if(sd_shopbtnlink!="" && sd_shopbtnlink!=null){
          var shoplink = '' + sd_shopbtnlink +'';
        }else{
          var shoplink = 'https://' + hostname +'/collections/all';
        }
        cart_list.push('<div class="empty-cart-container"><h2 class="sd_cartheading heading" style="text-align: left;margin-top: 9px;margin-bottom: 0;text-transform: lowercase;letter-spacing: 0;font-family: arial;font-size:16px;font-weight:600;"><div class="item-in-your-cart  sdi-cart-txt"><h3>'+itemsinyourcart+'</h3><hr style="border-bottom: 2px dotted rgb(204, 204, 204); margin: 10px auto; width: 100%; border-top: none;"></div><div class="cart-item-container"><div class="media-body empty-media"><figure><img src="https://i.ibb.co/Gpk9gLj/empty-cart.png" alt="empty-cart"></figure><h3 class="row mini-cart-product">'+cartempty+'</h3></div><div class="bottom-cart-box"><div class="cart-btn-container">');
        if(disableshop == 'nodisable')
        {
          cart_list.push('<a href="'+shoplink+'" class="cont-shopping sd_shopproduct">'+shopbuttontext+'</a>');
        }
        cart_list.push('</div></div></div></div>');
        if(disableshop=="disableshop")
        {
          $('.sd_shopproduct').css({'display':'none'});
        }
        else{
          $('.sd_shopproduct').css({'display':'block'});
        }
        if(sd_carttemplate == 'Custom')
        {
          if(cbuttonclr!=null && cbuttonclr!='#')
          {
            $('.sd_mini-cart-items .b_checkout').css({'background': cbuttonclr});
            $('.sd_mini-cart-items .sd_shopproduct').css({'background': cbuttonclr});
          }

          if(cartbuttontextcolorf!=null && cartbuttontextcolorf!='#')
          {
            $('.sd_mini-cart-items .b_checkout').css({'color': cartbuttontextcolorf});
            $('.sd_mini-cart-items .sd_shopproduct').css({'color': cartbuttontextcolorf});
          }

          if(ctxt!=null && ctxt!='#')
          {
            $('.cartproname a').css({'color': ctxt});
          }

          if(pricequant!=null && pricequant!='#')
          {
            $('.totalprice').css({'color': pricequant});
            $('.product_qua').css({'color': pricequant});
            $('.product_price').css({'color': pricequant});
            $('h2 span').css({'color': pricequant});
          }
        }
        $('.sd_mini-cart-items').css({'background': '#fff'});
        $('.sd_mini-cart-items').html(cart_list.join(''));
      }
    }
  });
}


function append_slider(){
var slider_data = [], array3 = [], finalAry = [], check_dataAry = [];
  if(sdrelated_enable == 'yesenablerelated' || sdrelated_enable == null || sdrelated_enable == '')
  {
    var hide_Products = JSON.parse("[" + sd_hideProducts + "]");
    $.each(cart_prdctidsary, function(key, productid_value) {
        var randomProducts_id = [];
      jQuery.getJSON("/recommendations/products.json?product_id="+productid_value).done(function(response){
        var recommendedProduct = response.products;
        console.log(recommendedProduct);
        if (recommendedProduct.length > 0) {
          recommendedProducts = recommendedProduct;
          $.each(recommendedProducts, function(key, related_products) {
            randomProducts_id.push(related_products.id);
          });
                    var intersectingValues=getArraysIntersection(randomProducts_id, hide_Products);// find common values between two arrays
             array3 = randomProducts_id.filter(function(obj) { return intersectingValues.indexOf(obj) == -1; });// Find different values from two arrays
                    if(array3.length > 0){
             related_status = 'true';
             finalAry = array3.slice(0, 3);
            }else{
              related_status = 'false';
            }
        }
        else{
          related_status = 'false';
        }
      })
      .fail(function(){
        related_status = 'false';
      });
      if(related_status == 'true')
      {
        return false;
      }
    });

    setTimeout(function() {
        if(recommendedProducts != '' && recommendedProducts != undefined && related_status == 'true')
    {
          setTimeout(function() {
       $('.productbox').addClass('sd_sliderenable');
      }, 50);
      slider_data.push('<h3 class="heading sd_heading">You May also like these</h3><div class="slidebox"><div id="slider">');
      slider_data.push('<ul class="slider-inner">');
      $.each(recommendedProducts, function(key, related_products) {
        var varIndex = 0;
        if(jQuery.inArray(related_products.id, finalAry) != -1){
        var variant_length = related_products.variants.length;
        if(show_soldout == 'yes'){
        $.each(related_products.variants, function(var_key, related_variants) {
          if(related_variants.available == true)
          {
          sd_sliderhtml = '<li class="slide-item"><div class="slide-image"><a href="javascript:void(0);"><img src="' + related_products.featured_image + '"  alt="' + related_products.title + '" /></a></div><div class="sd_slidertext"><div class="slide-text"><a href="javascript:void(0);">'+related_products.title+'</a><p class="prices" style="color:'+pricequant+';">'+ money +' '+related_variants.price/100+'</p><div class="slide-add">';
          return false;
          }
        });
        }else{
        sd_sliderhtml = '<li class="slide-item"><div class="slide-image"><a href="javascript:void(0);"><img src="' + related_products.featured_image + '"  alt="' + related_products.title + '" /></a></div><div class="sd_slidertext"><div class="slide-text"><a href="javascript:void(0);">'+related_products.title+'</a><p class="prices" style="color:'+pricequant+';">'+ money +' '+related_products.price/100+'</p><div class="slide-add">';
        }
        if(variant_length > 1){
          sd_sliderhtml += '<select id="sd_mySelectionBox'+related_products.id+'" class="sd_mySelection" product-id = "'+related_products.id+'">';
        }else if(variant_length == 1){
          sd_sliderhtml += '<select id="sd_mySelectionBox'+related_products.id+'" class="sd_mySelection sd_onevariant" style="display:none;" product-id = "'+related_products.id+'">';
        }

        $.each(related_products.variants, function(var_key, related_variants) {
          if(related_variants.available == true)
          {
                  sd_sliderhtml += '<option variant_id="'+related_variants.id+'" data-id = "sd_instock" product-price = "'+money +' '+related_variants.price/100+'">'+related_variants.title+'</option>';
          }else if(show_soldout != 'yes'){
                sd_sliderhtml += '<option variant_id="'+related_variants.id+'" data-id="sd_soldout" product-price = "'+money +' '+related_variants.price/100+'">'+related_variants.title+'(Sold Out)</option>';
          }
        });

        if(related_products.variants[0].available == true || show_soldout == 'yes'){
               var sd_addbtn = '<span><svg width="10" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg"><path d="M11 5H7V1a1 1 0 00-2 0v4H1a1 1 0 000 2h4v4a1 1 0 002 0V7h4a1 1 0 000-2z" fill="currentColor" fill-rule="nonzero"></path></svg></span>Add';
        }else if(show_soldout != 'yes'){
               var sd_addbtn = 'Sold Out';
        }
        sd_sliderhtml += '</select><button id="sd_add_to_cart" class="sd_add_to_cart" data-id="'+related_products.id+'" type="button">'+sd_addbtn+'</button></div></div></li>';
          slider_data.push(sd_sliderhtml);
              }
      });
      slider_data.push('</ul></div></div>');
      $('.sd_sliderdata').html(slider_data.join(''));
    }
    }, 700);
  }
  else if((sdrandom_enable == 'yesenablerandom' && randomProducts_data != '' && randomProducts_data != null && randomProducts_data != undefined) || (sdpopular_enable == 'yesenablepopular' && randomProducts_data != '' && randomProducts_data != null && randomProducts_data != undefined))
  {
    setTimeout(function() {
      $('.productbox').addClass('sd_sliderenable');
    }, 50);
    slider_data.push('<h3 class="heading sd_heading">You May also like these</h3><div class="slidebox"><div id="slider">');
    slider_data.push('<ul class="slider-inner">');
    $.each(randomProducts_data, function(key, related_products) {
      if(show_soldout == 'yes'){
      var addProduct = 'false';
      }else{
        var addProduct = 'true';
      }
      var variant_length = related_products.variants.length;
              imageurl = related_products.image.src;
      if( imageurl == null)
          { imageurl  = base_url+'images/no-image.png'; }
    if(show_soldout == 'yes'){
        $.each(related_products.variants, function(var_key, related_variants) {
          if(related_variants.inventory_quantity > 0 || related_variants.inventory_policy == 'continue')
          {
      sd_sliderhtml = '<li class="slide-item"><div class="slide-image"><a href="javascript:void(0);"><img src="' + imageurl + '"  alt="' + related_products.title + '" /></a></div><div class="sd_slidertext"><div class="slide-text"><a href="javascript:void(0);">'+related_products.title+'</a><p class="prices" style="color:'+pricequant+';">'+ money +' '+related_variants.price+'</p><div class="slide-add">';
        return false;
          }
        });
        }else{
      sd_sliderhtml = '<li class="slide-item"><div class="slide-image"><a href="javascript:void(0);"><img src="' + imageurl + '"  alt="' + related_products.title + '" /></a></div><div class="sd_slidertext"><div class="slide-text"><a href="javascript:void(0);">'+related_products.title+'</a><p class="prices" style="color:'+pricequant+';">'+ money +' '+related_products.variants[0].price+'</p><div class="slide-add">';
      }

        if(variant_length >1){
              sd_sliderhtml += '<select id="sd_mySelectionBox'+related_products.id+'" class="sd_mySelection" product-id = "'+related_products.id+'">';
        }else if(variant_length == 1){
          sd_sliderhtml += '<select id="sd_mySelectionBox'+related_products.id+'" style="display:none;" class="sd_mySelection" product-id = "'+related_products.id+'">';
        }
      $.each(related_products.variants, function(var_key, related_variants) {
        if(related_variants.inventory_quantity > 0 || related_variants.inventory_policy == 'continue')
        {
            addProduct = 'true';
          sd_sliderhtml +='<option variant_id="'+related_variants.id+'" data-id = "Add" product-price = "'+money +' '+related_variants.price+'">'+related_variants.title+'</option>';

        }
        else if(show_soldout != 'yes'){
          sd_sliderhtml +='<option variant_id="'+related_variants.id+'" data-id = "sd_soldout" product-price = "'+money +' '+related_variants.price+'">'+related_variants.title+'</option>';
        }
      });
      if(related_products.variants[0].inventory_quantity > 0 || related_products.variants[0].inventory_policy == 'continue' || show_soldout == 'yes'){
             var sd_addbtn = '<span><svg width="10" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg"><path d="M11 5H7V1a1 1 0 00-2 0v4H1a1 1 0 000 2h4v4a1 1 0 002 0V7h4a1 1 0 000-2z" fill="currentColor" fill-rule="nonzero"></path></svg></span>Add';
      }else if(show_soldout != 'yes'){
            var sd_addbtn = 'Sold Out';
      }
      sd_sliderhtml += '</select><button id="sd_add_to_cart" class = "sd_add_to_cart" data-id="'+related_products.id+'" type="button">'+sd_addbtn+'</button></div></div></div></li>';
     if(addProduct == 'true'){
      check_dataAry.push(sd_sliderhtml);
    }
    });
      if (show_soldout == 'yes' && check_dataAry.length === 0) {
      }else{
         slider_data.push(check_dataAry);
           slider_data.push('</ul></div></div>');
             $('.sd_sliderdata').html(slider_data.join(''));
        }
    }
}

// find common values from two array
function getArraysIntersection(a1,a2){
    return  a1.filter(function(n) { return a2.indexOf(n) !== -1;});
}

$('body').on('click', '.sd_dropdown-minibag', function() {
  setTimeout(function() {
    dropdowncart();
  }, 500);

  setTimeout(function() {
    $('.sd_dropdown-inner-area .sd_dropdown-cart-items').slideToggle('slow');
    $('.sd_dropdown-inner-area .sd_dropdown-cart-items').toggleClass('sd_active');
  }, 500);
});

function dropdowncart() {
  $.ajax({
    type: 'GET',
    url: 'https://' + hostname + '/cart.json',
    dataType: 'json',
    success: function(data) {
      var item_count = data['item_count'];
      var total_price = data['total_price'] / 100;
      var product_count = data['items'].length;
      if (item_count > 0) {
                    // cart count
                    $('.dropcount').text('(' + item_count + ')');
                }
                else
                {
                  $('.dropcount').text('(0)');
                }
                cart_list = [];
                cart_list.push('<form action="/cart" method="post" class="sd_cartform"><span class="close sd_dropdown-minibag">&#10006;</span>');
                //If there are items in cart
                if (item_count > 0) {
                    $('.sd_mini-cart').attr('id', 'mini-cart');
                    cart_list.push('<div class="product-outer"><div class="productbox"><h3 class="heading">'+item_count+' '+itemsinyourcart+'</h3>');
                    for (var i = 0; i < product_count; i++) {
                      if (data['items'][i]['id'] != null) {
                        var item_id = data['items'][i]['id'];
                        var product_title = data['items'][i]['product_title'];
                        var variant_title = data['items'][i]['variant_title'];
                        var product_handle = data['items'][i]['handle'];
                        var quantity = data['items'][i]['quantity'];
                        var line_price = data['items'][i]['price'] / 100;
                        var url = data['items'][i]['url'];
                        var image_url = data['items'][i]['image'];
                        var variants = data['items'][i]['variant_options'];
                        if(variant_title == null){
                          variant_title = '';
                        }
                        if(image_url == null)
                        {   image_url = base_url+'images/no-image.png'; }
                        if (product_title == 'Gift Wrap') {
                          var product_url = product_title;
                        } else {
                          var product_url = '<h3 class="title m-0"><a href="https://' + hostname + '' + url + '">' + product_title.substring(0, 7) + '...<span class="sd_variant">'+variant_title+'</span></a></h3>';
                        }
                        if(disablecheckout=="disablecheck"){
                          var dynabutton = '<a class="b_checkout" href="https://' + hostname + '/cart">'+viewcartbtntext+'</a>';
                        }else{
                          var dynabutton =  '<input id="sd_valid_discount" type="hidden" name="discount"><button name="checkout" class="b_checkout">'+checkoutbtntext+'</button>';
                        }
                        if(sddisablequantity=="disablequantity" && sddisablequantity!=null){
                          var quantitybox = '<span class="product_qua" style="padding-top:12px;">' + quantity + ' X </span>';
                        }
                        else {
                          var quantitybox = '<span class="sd_q_update quantitybox"><button type="button" class="sd_altera sdminus"><svg width="10" viewBox="0 0 12 2" xmlns="http://www.w3.org/2000/svg"><path d="M11.25 0H.75C.3 0 0 .4 0 1s.3 1 .75 1h10.5c.45 0 .75-.4.75-1s-.3-1-.75-1z" fill="#7A7A7A" fill-rule="nonzero"></path></svg></button><input type="text" id="sd_updatequant" name="updatequant" value="'+ quantity +'" proid="' + item_id + '" prokey="'+i+'"><button type="button" class="sd_altera sdplus down"><svg width="10" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg"><path d="M11 5H7V1a1 1 0 00-2 0v4H1a1 1 0 000 2h4v4a1 1 0 002 0V7h4a1 1 0 000-2z" fill="currentColor" fill-rule="nonzero"></path></svg></button></span>';
                        }
                        var options = [];
                        for (var o = 0; o < variants.length; o++) {
                          var selected = data['items'][i]['variant_options'][o];
                          if (selected !== 'Default Title') {
                            options.push(selected);
                          }
                        }
                        var selected_options = options.join('');
                        cart_list.push('<hr class="m-0"><div class="product-inner row mini-cart-product ' + item_id + '"><div class="product_image image"><a href="javascript:void(0);"><img src="' + image_url + '"  alt="' + product_title + '" /></a></div><div class="pro-content"><div class="cartproname prohead">' + product_url + '</div><div class="pro-quantity"><div class="quantity-selector"><span class="price product_price">' + ' ' + money + ' ' + line_price.toFixed(2) + '</span>'+ quantitybox + '<input type="hidden" id="updates_' + item_id + '" value="' + quantity + '" /> <span class="product_price"> </span><a class="removeproduct remove" id="bag_product"' + item_id + '"" href="https://' + hostname + '/cart/change?line=1&amp;quantity=0" rel="' + i + '">'+removetext+'</a></div></div></div></div>');
                        } //endif
                    } // endfor
                    cart_list.push('</div>');
                    cart_list.push('<div class="sd_side_mini-cart-subtotal checkoutbox"><div class="minitotal total"><span class="totalname">'+totaltext+'<strong class="totalprice">' + money + ' ' + total_price.toFixed(2) + '</strong></span></div><div class="sd_sidebar_check">'+dynabutton+'</div><a class="sd_viewcart" href="https://' + hostname + '/cart">'+viewcartbtntext+'</a><p class="sd_shipping">'+shippingmsg+'</p></div></form>');
                    //$('.totalprice').text(  );
                    if(Shopify.shop == 'gtglass.myshopify.com'){
                      console.log('4343');
                      console.log(money + ' ' + total_price.toFixed(2));
                      // $("#cart-price").html(money + ' ' + total_price.toFixed(2));
                      $(".sd-header-text").html(money + ' ' + total_price.toFixed(2));
                    }
                    console.log('carticonclickeeeeeeeeeed');
                    $('.sd_dropdown-cart-items').html(cart_list.join(''));

                    if(cbuttonclr!=null && cbuttonclr!='#')
                    {
                      $('.sd_dropdown-cart-items .b_checkout').css({'background': cbuttonclr});
                      $('.sd_maltera').css({'background': cbuttonclr});
                    }
                    else
                    {
                      $('.sd_dropdown-cart-items .b_checkout').css({'background': '#f9524c'});
                      $('.sd_maltera').css({'background': 'rgb(212, 210, 210)'});
                    }
                    if(dropheadfoot!=null && dropheadfoot!='#'){
                      $('.sd_dropdown-cart-items .mini-cart-subtotal').css({'background': dropheadfoot});

                    }
                    else {
                      $('.sd_dropdown-cart-items .mini-cart-subtotal').css({'background': '#f0f0f0'});
                    }

                    if(cartbuttontextcolorf!=null && cartbuttontextcolorf!='#')
                    {
                      $('.sd_dropdown-cart-items .b_checkout').css({'color': cartbuttontextcolorf});
                      $('.sd_maltera').css({'color': cartbuttontextcolorf});
                    }
                    else
                    {
                      $('.sd_dropdown-cart-items .b_checkout').css({'color': '#fff'});
                      $('.sd_maltera').css({'color': '#000'});

                    }

                    if(ctxt!=null && ctxt!='#')
                    {
                      $('.cartproname a').css({'color': ctxt});

                    }
                    if(pricequant!=null && pricequant!='#')
                    {
                      $('.totalprice').css({'color': pricequant});
                      $('.product_qua').css({'color': pricequant});
                      $('.product_price').css({'color': pricequant});
                      $('h2 span').css({'color': pricequant});

                    }
                    if(viewcartbtnback!=null && viewcartbtnback!='#')
                    {

                      $('.sd_viewcart').css({'background': viewcartbtnback});

                    }

                    if(viewcartbtntextcolor!=null && viewcartbtntextcolor!='#')
                    {
                      $('.sd_viewcart').css({'color': viewcartbtntextcolor});

                    }

                    if(disablecheckout=="disablecheck"){

                      $('.sd_viewcart').remove();

                    }else{
                    }


                }
                else {
                  if(disablecheckout=="disablecheck"){
                    var dynabutton = '<a class="b_checkout" href="https://' + hostname + '/cart">'+viewcartbtntext+'</a>';

                  }else{

                    var dynabutton =  '<form action="/cart" method="post"><input id="sd_valid_discount" type="hidden" name="discount"><button name="checkout" class="b_checkout">'+checkoutbtntext+'</button></form>';
                  }

                  if(sd_shopbtnlink!="" && sd_shopbtnlink!=null){

                    var shoplink = '' + sd_shopbtnlink +'';

                  }else{

                    var shoplink = 'https://' + hostname +'/collections/all';
                  }

                  if(disableshop=="disableshop")
                  {

                    $('.sd_shopproduct').css({'display':'none'});
                  }
                  else{
                    $('.sd_shopproduct').css({'display':'block'});
                  }
                  cart_list.push('<div class="empty-cart-container"><div class="item-in-your-cart"><h3>0 '+itemsinyourcart+'</h3></div><div class="cart-item-container"><div class="media "><div class="media-body empty-media"><figure><img src="https://i.ibb.co/Gpk9gLj/empty-cart.png" alt="empty-cart"></figure><p>'+cartempty+'</p></div></div><div class="bottom-cart-box"><div class="cart-btn-container"><a href="'+shoplink+'" class="cont-shopping">'+shopbuttontext+'</a></div></div></div></div>');

                  if(cbuttonclr!=null && cbuttonclr!='#')
                  {
                    $('.sd_dropdown-cart-items .b_checkout').css({'background': cbuttonclr});
                    $('.sd_dropdown-cart-items .sd_shopproduct').css({'background': cbuttonclr});
                  }
                  if(dropheadfoot!=null && dropheadfoot!='#'){
                    $('.sd_dropdown-cart-items .mini-cart-subtotal').css({'background': dropheadfoot});

                  }
                  if(cartbuttontextcolorf!=null && cartbuttontextcolorf!='#')
                  {
                    $('.sd_dropdown-cart-items .b_checkout').css({'color': cartbuttontextcolorf});
                    $('.sd_dropdown-cart-items .sd_shopproduct').css({'color': cartbuttontextcolorf});
                  }

                  if(ctxt!=null && ctxt!='#')
                  {
                    $('.cartproname a').css({'color': ctxt});

                  }

                  if(pricequant!=null && pricequant!='#')
                  {
                    $('.totalprice').css({'color': pricequant});
                    $('.product_qua').css({'color': pricequant});
                    $('.product_price').css({'color': pricequant});
                    $('h2 span').css({'color': pricequant});
                  }
                  $('.sd_dropdown-cart-items').html(cart_list.join(''));
                }
            }
        });
}


$(document).on('click','.sd_noteheading', function(){
  $(".sd_note__input").toggle();
});

$(document).on('click','.sd_closs_contain',function(){
  $('#sd_notification_main').hide();
});

$(document).on('click', '.sd_codebtn', function(){
  console.log('sd_codeButtonclick');
  var discount_value = $('#sd_discount').val();
  var original_total_price = $('.totalprice').text();
  var customer_id = window.ShopifyAnalytics.meta['page']['customerId'];
  if(discount_value == '')
  {
    $( '.invalid-coupon-code' ).css( "color", "red" );
    $('.invalid-coupon-code').text('Enter Discount Code');
  }
  else
  {

    $.ajax({
      type: 'POST',
      url: base_url+'discount_code.php',
      dataType: 'json',
      data:{discount_cd:'discount_cd', shopname : Shopify.shop, cart_data: resulting_data, discount_val: discount_value, customer_Id: customer_id},
      beforeSend: function(){
          // Show image container
          $(".fa-spin").show();
      },
      success: function(datares) {
        $(".fa-spin").hide();
        var error_message =  $.trim(datares.error_message);
        var discount_amount = $.trim(datares.payable_amount);
               //var new_discount = Math.round((Number(discount_amount) + Number.EPSILON) * 100) / 100;
               if(discount_amount != '')
               {
          // Check browser support
          if (typeof(Storage) !== "undefined") {
          // Store
          localStorage.setItem("lastdiscountcode", discount_value);
        }

        if(discount_amount == 'shipping_free')
        {
          $('.sd_discountamount').html('Free Shipping');
          $("#sd_valid_discount").val(discount_value);
          $('.sd_discount-box').html('<span class="footer-code" data = '+discount_value+'><svg class="footer-tags-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18" width="14px" height="14px"><path d="M17.78 3.09C17.45 2.443 16.778 2 16 2h-5.165c-.535 0-1.046.214-1.422.593l-6.82 6.89c0 .002 0 .003-.002.003-.245.253-.413.554-.5.874L.738 8.055c-.56-.953-.24-2.178.712-2.737L9.823.425C10.284.155 10.834.08 11.35.22l4.99 1.337c.755.203 1.293.814 1.44 1.533z" fill-opacity=".55" fill="currentColor"></path><path fill="currentColor" d="M10.835 2H16c1.105 0 2 .895 2 2v5.172c0 .53-.21 1.04-.586 1.414l-6.818 6.818c-.777.778-2.036.782-2.82.01l-5.166-5.1c-.786-.775-.794-2.04-.02-2.828.002 0 .003 0 .003-.002l6.82-6.89C9.79 2.214 10.3 2 10.835 2zM13.5 8c.828 0 1.5-.672 1.5-1.5S14.328 5 13.5 5 12 5.672 12 6.5 12.672 8 13.5 8z"></path></svg>'+discount_value+'<button class="sd_removediscount"><svg width="10" viewBox="0 0 10 10"><path d="M9.677 8.118a1.102 1.102 0 11-1.559 1.56L5 6.558 1.882 9.677a1.102 1.102 0 11-1.56-1.559L3.442 5 .323 1.882A1.102 1.102 0 111.882.322L5 3.442 8.118.323a1.102 1.102 0 111.56 1.559L6.558 5l3.118 3.118z" fill="#A1A1A1" fill-rule="nonzero"></path></svg></button></span>');
        }
        else
        {
        // $('.totalprice').css({"text-decoration":"line-through"});
        $('.totalprice').html(money + ' ' + discount_amount);
        if(Shopify.shop == 'gtglass.myshopify.com'){
          $(".sd-header-text").text(money + ' ' + discount_amount.toFixed(2));
        }
        $('.sd_discountamount').html(original_total_price);
        $('.sd_discountamount').css({"text-decoration":"line-through"});
        $("#sd_valid_discount").val(discount_value);
        $('.sd_discount-box').html('<span class="footer-code" data = '+discount_value+'><svg class="footer-tags-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18" width="14px" height="14px"><path d="M17.78 3.09C17.45 2.443 16.778 2 16 2h-5.165c-.535 0-1.046.214-1.422.593l-6.82 6.89c0 .002 0 .003-.002.003-.245.253-.413.554-.5.874L.738 8.055c-.56-.953-.24-2.178.712-2.737L9.823.425C10.284.155 10.834.08 11.35.22l4.99 1.337c.755.203 1.293.814 1.44 1.533z" fill-opacity=".55" fill="currentColor"></path><path fill="currentColor" d="M10.835 2H16c1.105 0 2 .895 2 2v5.172c0 .53-.21 1.04-.586 1.414l-6.818 6.818c-.777.778-2.036.782-2.82.01l-5.166-5.1c-.786-.775-.794-2.04-.02-2.828.002 0 .003 0 .003-.002l6.82-6.89C9.79 2.214 10.3 2 10.835 2zM13.5 8c.828 0 1.5-.672 1.5-1.5S14.328 5 13.5 5 12 5.672 12 6.5 12.672 8 13.5 8z"></path></svg>'+discount_value+'<button class="sd_removediscount"><svg width="10" viewBox="0 0 10 10"><path d="M9.677 8.118a1.102 1.102 0 11-1.559 1.56L5 6.558 1.882 9.677a1.102 1.102 0 11-1.56-1.559L3.442 5 .323 1.882A1.102 1.102 0 111.882.322L5 3.442 8.118.323a1.102 1.102 0 111.56 1.559L6.558 5l3.118 3.118z" fill="#A1A1A1" fill-rule="nonzero"></path></svg></button></span>');
      }
    }
    else if(error_message != '')
    {
      if(error_message == 'non-predictable')
      {
        $('.sd_notpredict' ).css( "color", "green");
        $("#sd_valid_discount").val(discount_value);
        $('.sd_notpredict').text('Discount will apply on checkout');
      }
      else
      {
        $('.invalid-coupon-code' ).css( "color", "red");
        $('.invalid-coupon-code').text(error_message);
        $("#sd_valid_discount").val('');
      }
    }
    else{
      $( '.invalid-coupon-code' ).css( "color", "red" );
      $('.invalid-coupon-code').text('Code not Matched');
    }
  }
});
}

});

function swipe_slick(){
  $('.slider-inner').not('.slick-initialized').slick(
  {
    dots: true,
    arrows: true,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    adaptiveHeight: true,
    nextArrow: '<a href="#" class="control_next"><img src='+base_url+'images/slide-right-arrow.svg></a>',
    prevArrow: '<a href="#" class="control_prev"><img src='+base_url+'images/slide-left-arrow.svg></a>'
  }
  );
}

    //remove from ajax cart
    $(document).on('click', '.removeproduct', function()
    {
      var discount_value = $('.footer-code').attr('data');
      var lineno = $(this).attr("rel");
      var line_item = parseInt(lineno) + 1;
      var pid = $(this).attr("id");
      $.ajax({
        type: 'POST',
        url: '/cart/change.js',
        data: 'quantity=0&line=' + line_item,
        async: false,
        cache: false,
        dataType: 'json',
        success: function(cartdata)
        {
          setTimeout(function() {
            $('.sd_minifixinner').click();
            dropdowncart();
          }, 800);
          if(discount_value != '' && discount_value != undefined)
          {
            setTimeout(function() {
              $("#sd_discount").val(discount_value);
              $('.sd_codebtn').click();
            }, 600);
          }
        }
      });
      return false;
    });
    /* end remove cart items */

//update product counter when click on the add to cart button
$('body,html').on('click', 'form[action="/cart/add"] button[type="submit"],form[action="/cart/add"] input[type="submit"],form[action="/cart/add"] input[type="button"],form[action="/cart/add"] button[type="button"]', function(e) {

  $.ajax({
    type: 'GET',
    url: 'https://' + hostname + '/cart.json',
    dataType: 'json',
    success: function(datas) {
      var sd_countertotal = datas['item_count'];

      $('.sd_procounter').text(sd_countertotal);
      $('#CartCount span').text(sd_countertotal);
      $('.dropcount').text('('+sd_countertotal+')');

    }
  });
});

$('input').on('click', function(e) {

  $.ajax({
    type: 'GET',
    url: 'https://' + hostname + '/cart.json',
    dataType: 'json',
    success: function(datas) {
      var sd_countertotal = datas['item_count'];

      $('.sd_procounter').text(sd_countertotal);
      $('#CartCount span').text(sd_countertotal);
      $('.dropcount').text('('+sd_countertotal+')');

    }
  });
});

$('button').on('click', function(e) {
  $.ajax({
    type: 'GET',
    url: 'https://' + hostname + '/cart.json',
    dataType: 'json',
    success: function(datas) {
      var sd_countertotal = datas['item_count'];
      $('.sd_procounter').text(sd_countertotal);
      $('#CartCount span').text(sd_countertotal);
      $('.dropcount').text('('+sd_countertotal+')');
    }
  });
});

$('body,html').on('click', 'input[type="button"]', function(e) {
  $.ajax({
    type: 'GET',
    url: 'https://' + hostname + '/cart.json',
    dataType: 'json',
    success: function(datas) {
      var sd_countertotal = datas['item_count'];
      $('.sd_procounter').text(sd_countertotal);
      $('#CartCount span').text(sd_countertotal);
      $('.dropcount').text('('+sd_countertotal+')');
    }
  });


});


// on click outside close cart drawer
$(window).click(function(evt) {
  if($(evt.target).closest('.sd_mini-cart-items,.sd_minifixinner').length == 0)
  {
    if(sd_iconposition=="left")
    {
      if ($(".sd_left_minicart")[0])
      {
        $(".sd_left .sidesd_cross_image").click();
      }
    }
    else
    {
      if ($(".sd_right_minicart")[0])
      {

        $(".sd_right .sidesd_cross_image").click();
      }
    }
  }
});

$('body,html').on('click', 'button[type="button"]', function(e) {

  $.ajax({
    type: 'GET',
    url: 'https://' + hostname + '/cart.json',
    dataType: 'json',
    success: function(datas) {
      var sd_countertotal = datas['item_count'];
      $('.sd_procounter').text(sd_countertotal);
      $('#CartCount span').text(sd_countertotal);
      $('.dropcount').text('('+sd_countertotal+')');
    }
  });

});

$('body,html').on('bind', 'input[type="submit"]', function(e) {
  $.ajax({
    type: 'GET',
    url: 'https://' + hostname + '/cart.json',
    dataType: 'json',
    success: function(datas) {
      var sd_countertotal = datas['item_count'];
      $('.sd_procounter').text(sd_countertotal);
      $('#CartCount span').text(sd_countertotal);
      $('.dropcount').text('('+sd_countertotal+')');
    }
  });
});
})();
});